<wlm-dynamic-layout
  *ngIf="isConfigured && dynamicLayoutSettings"
  [settings]="dynamicLayoutSettings"
  [containerClass]="containerClass"
></wlm-dynamic-layout>
